<template>
  <v-text-field v-bind="attributes"
                v-on="listeners"
                :value="value"
                :error="hasFieldErrors"
                @change="change"
                ref="proxy"/>
</template>

<script>
import InputMixin from '../mixins/input';

const DEFAULTS = {
  clearable: false,
  autocomplete: 'off',
  spellcheck: 'false',
  autocorrect: 'off',
  autocapitalize: 'off'
};

export default {
  mixins: [ InputMixin ],
  computed: {
    attributes () {
      let result = Object.assign({}, DEFAULTS, this.$attrs);
      this.mixinRequired(result);

      return result;
    },
    listeners () {
      return this.$listeners;
    }
  },
  methods: {
    change (value) {
      let result = this.trimToNull(value);
      if (result)
      {
        let time = this.$cove.parseTime(result);
        if (time !== null)
        {
          result = this.$cove.formatTime(time);
        }
      }

      if (result !== value)
      {
        this.$emit('input', result);
        this.$emit('change', result);
      }
    }
  }
};
</script>
